import { useToast } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

export const useDownloadErrorFile = (options: {
  fileUrl?: string;
  shouldDownload: boolean;
}): void => {
  const toast = useToast();
  const { fileUrl, shouldDownload } = options;
  const { isReady, replace, query } = useRouter();

  const downloadErrorFile = React.useCallback(
    (fileUrl: string): void => {
      if (isReady) {
        const element = document.createElement('a');
        element.setAttribute('href', fileUrl);
        element.setAttribute('download', '');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
        toast({
          status: 'success',
          description: 'Successfully downloaded csv upload error file.',
        });

        const { userCsvUploadId, userGroupLinkCsvUploadId, ...rest } = query;
        replace({ query: rest });
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toast, isReady]
  );

  React.useEffect(() => {
    if (!shouldDownload || !fileUrl) {
      return;
    }

    downloadErrorFile(fileUrl);
  }, [downloadErrorFile, fileUrl, shouldDownload]);
};
